import {Component, Input} from '@angular/core';
import {BaseComponent} from '../base.component';
import {Subject} from 'rxjs';
import {SessionStorageService} from '../../services/session-storage.service';


@Component({
    selector: 'ui-reload-page-modal',
    templateUrl: './reload-page-modal.component.html',
    styleUrls: ['./reload-page-modal.component.less']
})
export class ReloadPageModalComponent extends BaseComponent {
    subject: Subject<any>;
    componentName = 'SessionExpirationModalComponent';

    @Input() title: string;
    @Input() id: number;
    @Input() hideIcon = false;
    @Input() applyText: string;

    constructor(
        private sessionStorageService: SessionStorageService
    ) {
        super();
    }

    refreshPage(): void {
        location.reload();
    }

    close(): void {
        this.complete(null);
    }

    private complete(resolved: any): void {
        this.subject.next(resolved);
        this.subject.complete();
    }
}
